module.exports = __webpack_public_path__ + "static/media/kpg-accountants-banner2.ca328fac.jpg";